var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"costInfo-page"},[_c('div',{staticClass:"costInfo-page-title"},[_vm._v(" About credits usage ")]),_c('div',{staticClass:"costInfo-page-content"},[_vm._v(" Image face swapping will cost 1 credit. Video face swapping will cost 1 credit per second. ")])])
}]

export { render, staticRenderFns }